import { useEffect, useState } from 'react';

/**
 * Returns a copy of `value` that only updates after `delayMs` has elapsed
 * without a further change. The pending update is cancelled on unmount or when
 * the value changes again, so a trailing update can never land after the input
 * has moved on (or been cleared).
 */
export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(timeoutId);
  }, [value, delayMs]);

  return debouncedValue;
};
